module.exports = __webpack_public_path__ + "img/s5-2.91157d4a.jpg";